import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RegularCellComponent } from '@schoolbelle/common/table';
import { possible_search_type_list } from '../mailmerge-table.service';

@Component({
  selector: '[header-cell]',
  templateUrl: './header-cell.component.html',
  styleUrls: ['./header-cell.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MailmergeHeaderCellComponent extends RegularCellComponent {
  get restricted_words ():string[] {
    return this.cell.table.rows[0].cells.slice(0, possible_search_type_list.length).map(c=>c.val).filter(v=>v);
  }
}
